import { render, staticRenderFns } from "./TextBoxDragHandles.vue?vue&type=template&id=2b463578&scoped=true&"
import script from "./TextBoxDragHandles.vue?vue&type=script&lang=ts&"
export * from "./TextBoxDragHandles.vue?vue&type=script&lang=ts&"
import style0 from "./TextBoxDragHandles.vue?vue&type=style&index=0&id=2b463578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b463578",
  null
  
)

export default component.exports